{
  "home.hero.headline": "Hatch it. Raise it. Battle with it.",
  "home.hero.starterPrompt": "Choose your first Suikamon.",
  "home.hero.hatch": "Hatch {species}",
  "home.hero.play": "Play Now",
  "home.hero.signInPrompt": "No account needed. Already playing?",
  "home.hero.signIn": "Sign in",
  "home.hero.continue": "Continue playing",
  "home.hero.savePrompt": "Keep your Suikamon forever —",
  "home.hero.signUp": "Sign up free",
  "home.hero.loading": "Loading...",
  "home.modes.title": "Three ways to play",
  "home.modes.raise.title": "Raise",
  "home.modes.raise.line": "Feed, clean and train it. It evolves through six forms as it levels up.",
  "home.modes.raise.cta": "Try the care demo",
  "home.modes.raise.alt": "Aqua, a water Suikamon, at its third evolution",
  "home.modes.battle.title": "Battle",
  "home.modes.battle.line": "Four moves and a hand of cards. Practice fights need no pet and no account.",
  "home.modes.battle.cta": "Fight in the Battle Lab",
  "home.modes.battle.alt": "Talion, a fox Suikamon, hooded and ready to fight",
  "home.modes.campaign.title": "Campaign",
  "home.modes.campaign.line": "The Last Souls: beat rivals and bring the island's Soul Shards home. Tale 1 is open.",
  "home.modes.campaign.cta": "Play the campaign",
  "home.modes.campaign.alt": "Gorly, the First Guardian, from the campaign",
  "home.demo.title": "Your Suikamon's first day",
  "home.demo.caption": "Real gameplay · Talion, from egg to its first win",
  "home.demo.videoLabel": "Gameplay: the three free starters, Talion hatches, is fed and cleaned, the story begins, and it evolves mid-battle and wins",
  "home.demo.hatch.title": "Hatch",
  "home.demo.hatch.line": "Pick a starter and warm its egg.",
  "home.demo.raise.title": "Raise",
  "home.demo.raise.line": "Feed it, clean it, keep it happy.",
  "home.demo.story.title": "Story",
  "home.demo.story.line": "A whole island needs a brave Keeper.",
  "home.demo.battle.title": "Battle",
  "home.demo.battle.line": "Fight together and evolve mid-fight.",
  "home.section.speciesMore": "See every Suikamon",
  "home.section.questions": "Questions",
  "home.section.closing": "Your Suikamon is waiting",
  "home.section.closingContinue": "Continue playing",
  "home.section.closingCta": "Pick your starter",
  "home.section.helpLink": "More questions? Help and full FAQ",
  "home.section.community": "Community",
  "home.faq.free.q": "Is it free?",
  "home.faq.free.a": "Yes. The whole game is free to play.",
  "home.faq.account.q": "Do I need an account?",
  "home.faq.account.a": "No. Pick a starter and play. Sign up when you want to keep your Suikamon and lift the guest level cap.",
  "home.faq.phone.q": "Does it work on my phone?",
  "home.faq.phone.a": "Yes. It runs in your browser on phone, tablet and desktop, with no download.",
  "home.faq.payToWin.q": "Is it pay-to-win?",
  "home.faq.payToWin.a": "No. A few minutes of care a day is enough, and battles are won with the moves and cards you play.",
  "home.discover.tokenLabel": "{species}, {rarity} {element}",
  "home.discover.tokenLabelStarter": "{species}, {rarity} {element}, free starter",
  "home.discover.tokens": "Every Suikamon",
  "home.discover.startWith": "Start with {species} free",
  "home.discover.allAbout": "All about {species}",
  "home.lobby.resting": "💤 Resting",
  "home.lobby.tokenLabel": "{name}, level {level}",
  "home.lobby.tokenLabelResting": "{name}, level {level}, resting",
  "home.lobby.tokens": "Your Suikamon",
  "home.starterCard.choose": "Choose {species}, {element}",
  "home.journey.visitor": "Start playing free in seconds — or sign up to keep your Suikamon and save your progress.",
  "home.journey.signedIn": "Pick your free starter — it's yours in seconds.",
  "home.journey.title": "Your companion awaits!",
  "home.journey.eggAlt": "Suikamon egg",
  "home.journey.startNow": "Start Now",
  "home.journey.signUp": "Sign Up",
  "home.startPlaying.heading": "Start playing",
  "home.startPlaying.titleNamed": "Play {species} now",
  "home.startPlaying.title": "Play your first Suikamon",
  "home.startPlaying.subtitleNamed": "Raise your own {species} for free — no sign-up needed. Sign up any time to keep it and save your progress.",
  "home.startPlaying.subtitle": "Pick a Suikamon and start raising it in seconds — free, no sign-up.",
  "home.startPlaying.imageAlt": "{species} ready to play",
  "home.banner.titleNamed": "Play {species} free",
  "home.banner.subtitleNamed": "Raise your own {species} — free, no sign-up.",
  "home.banner.subtitle": "Free to start — pick a Suikamon and play in seconds.",
  "home.banner.cta": "▶ Play free",
  "home.community.join": "Join <b>{count}</b> trainers owning Suikamons",
  "home.community.pets": "Suikamons",
  "home.community.battles": "Battles",
  "home.community.meals": "Meals",
  "home.community.poops": "Poops",
  "home.community.trainings": "Trainings",
  "home.community.meds": "Meds",
  "home.speciesRail.viewAria": "View {species}",
  "home.speciesRail.view": "View →",
  "home.news.latest": "Latest news"
}
